null


// WEBPACK FOOTER //
// https://raw.githubusercontent.com/scala-js/scala-js/v0.6.25/javalanglib/src/main/scala/java/lang/StringBuilder.scala